/**
 * @generated SignedSource<<4dd1d47b3e988dfbad2e7b7056df16eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderWithSimpleMenu_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SimpleMenuMainNavigation_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderAuthenticatedUser_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": "__isViewer"
};

node.hash = "2cd61f7221c2b6d5d78552305694a5eb";

module.exports = node;
